import { takeEvery } from 'redux-saga/effects';

import * as actions from 'store/modules/additionalDrivers';

import { load } from './utils';

export default function* listenRemoveDriver() {
  yield takeEvery(actions.load.toString(), load);
}
